<template>
  <v-card flat class="pa-6">
    <v-card-title class="text-h6 primary--text mb-6">
      {{ $t("general_game_settings") }}
    </v-card-title>

    <v-card-text v-if="gameConfig">
      <v-row dense>
        <!-- تنظیمات بازی اول: از configConfig -->
        <template v-if="gameType === 'Game' && configSchema">
          <v-col cols="12">
            <h5 class="mb-4 primary--text font-weight-medium">
              {{ $t("game_parameters") }}
            </h5>
          </v-col>

          <v-col
            v-for="(field, key) in configSchema"
            :key="key"
            cols="12"
            md="6"
          >
            <v-text-field
              :value="getSafeValue(`config.${key}`)"
              @input="setSafeValue(`config.${key}`, Number($event))"
              :label="field.label"
              type="number"
              :min="field.min || 1"
              :max="field.max || 1000"
              outlined
              dense
              :hint="getHint(key)"
              persistent-hint
            />
          </v-col>
        </template>

        <!-- تنظیمات بازی دوم: از gameplayConfig -->
        <template v-if="gameType === 'MeepMeepProRunner' && gameplaySchema">
          <v-col cols="12">
            <h5 class="mb-4 primary--text font-weight-medium">
              {{ $t("gameplay_parameters") }}
            </h5>
          </v-col>

          <v-col
            v-for="(field, key) in gameplaySchema"
            :key="key"
            cols="12"
            md="6"
          >
            <v-text-field
              :value="getSafeValue(`gameplay.${key}`)"
              @input="setSafeValue(`gameplay.${key}`, Number($event))"
              :label="field.label"
              type="number"
              :min="field.min || 0"
              :max="field.max || 100"
              outlined
              dense
              :hint="getHint(key)"
              persistent-hint
            />
          </v-col>
        </template>

        <!-- اگر هیچ schema تنظیماتی نبود -->
        <v-col v-if="!hasAnySettings" cols="12">
          <v-alert type="info" text prominent>
            تنظیمات عمومی برای این نوع بازی تعریف نشده است.
          </v-alert>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { get, set } from "lodash";

export default {
  name: "TabSetting",

  props: {
    value: { type: Object, required: true },
    schema: { type: Object, required: true },
  },

  computed: {
    gameConfig: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    gameType() {
      return this.gameConfig?.type || null;
    },

    configSchema() {
      return this.schema?.configConfig || {};
    },
    gameplaySchema() {
      return this.schema?.gameplayConfig || {};
    },

    hasAnySettings() {
      return (
        Object.keys(this.configSchema).length > 0 ||
        Object.keys(this.gameplaySchema).length > 0
      );
    },
  },

  methods: {
    getSafeValue(path) {
      return get(this.gameConfig, path);
    },
    setSafeValue(path, val) {
      // Use Vue.set to ensure reactivity
      const parts = path.split('.');
      let obj = this.gameConfig;
      
      // Navigate to the parent object
      for (let i = 0; i < parts.length - 1; i++) {
        if (!obj[parts[i]]) {
          this.$set(obj, parts[i], {});
        }
        obj = obj[parts[i]];
      }
      
      // Set the final property
      this.$set(obj, parts[parts.length - 1], val);
      this.$emit("input", { ...this.gameConfig });
    },
    getHint(key) {
      const hints = {
        initialLives: "تعداد جان اولیه (۱ تا ۵ توصیه می‌شود)",
        pointsPerQR: "امتیاز هر QR اسکن‌شده",
        magnetThreshold: "امتیاز لازم برای فعال شدن آهنربا",
        magnetDuration: "مدت زمان آهنربا (میلی‌ثانیه)",
        spawnRateEnemy: "فاصله تولید موانع (فریم، کمتر = سخت‌تر)",
        spawnRateQR: "فاصله تولید QRها (فریم)",
        minSpeed: "حداقل سرعت اشیاء",
        maxSpeed: "حداکثر سرعت اشیاء",
        lanesCount: "تعداد لاین‌ها (معمولاً ۳)",
        baseSpeed: "سرعت شروع بازی",
        maxSpeed: "حداکثر سرعت",
        speedStep: "افزایش سرعت هر مرحله",
        jumpForce: "قدرت پرش (عدد منفی)",
        gravity: "نیروی جاذبه",
        minScoreToSubmit: "حداقل امتیاز برای نمایش فرم شماره",
      };
      return hints[key] || "";
    },
  },
};
</script>

<style scoped>
.v-alert {
  border-left: 4px solid var(--v-info-base) !important;
}
</style>
